// extracted by mini-css-extract-plugin
module.exports = {"commonIndent":"InnerContent__commonIndent___1Uyim","extraFormIndent":"InnerContent__extraFormIndent___xBBvH"};